import React from "react";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import { Box, makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CardActionArea from "@material-ui/core/CardActionArea";
import { useDeckData } from "../../../Providers/Data/DeckDataProvider.jsx";
import { useBaseData } from "../../../Providers/Data/BaseDataProvider.jsx";
import QuadraticProgress from "../../../SharedComponents/QuadraticProgress.jsx";
import LessonCompletedIcon from "../../../SharedComponents/LessonCompletedIcon.jsx";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    width: 190,
    height: 160,
    margin: "11px 6px",
    padding: 12,
    borderRadius: 12,
    position: "relative",
    backgroundColor: "transparent",
    "& .MuiCardActionArea-root": {
      "&:hover, &:focus, &:active": {
        backgroundColor: "transparent",
      },
    },
    "& .Mui-focusVisible": {
      backgroundColor: "transparent",
    },
    "& .MuiCardActionArea-focusHighlight": {
      backgroundColor: "transparent",
    },
    "&:hover, &:focus, &:active": {
      backgroundColor: "#FAFBFB",
    },
    [theme.breakpoints.down("md")]: {
      width: 130,
    },
  },
  progressContainer: {
    position: "relative",
    marginBottom: 8,
    width: 90,
    height: 90,
    flexShrink: 0,
  },
  progress: {
    width: 90,
    height: 90,
    borderRadius: 22,
    boxShadow: "0 0 16.53px rgba(0, 0, 0, 0.12)",
    backgroundSize: "cover",
    backgroundPosition: "bottom, center",
    flexShrink: 0,
  },
  cardContent: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 0,
  },
  circulaProgress: {
    margin: "auto 0",
  },
  linearProgress: {
    width: "100%",
    margin: "auto 0 0",
  },
  deckName: {
    textAlign: "center",
    padding: "4px 0 0",
    "& .MuiTypography-root": {
      color: "#1B1C1C",
      fontSize: 14,
      lineHeight: 1.4,
      height: "40px",
      overflow: "hidden",
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
    },
  },
}));

/**
 * Показывает карточку урока с фактическим прогрессом и признаком завершения.
 */
const DeckCard = () => {
  const { userInfo } = useBaseData();
  const { deck, branch, onCardClick, progressValue } = useDeckData();
  const illustrationImage = (deck.illustrationImageUrl || deck.illustrationImage?.url)
    ?.replace(/\\/g, "/")
    ?.replace(/'/g, "%27");
  const classes = useStyles({ illustrationImage });
  const isLock = !branch.open || !deck.open || !(userInfo.isActive || userInfo.isDemoMode);
  // Зачёт определяется серверным статусом, а процент остаётся фактическим прогрессом урока.
  const isCompleted = deck.learned;

  // // Динамика вынесена в inline-стили, чтобы не генерировать JSS-классы на каждую карточку
  const cardInlineStyle = {
    backgroundImage: illustrationImage
      ? isLock
        ? `linear-gradient(rgba(255,255,255,0.6), rgba(255,255,255,0.6)), url(${illustrationImage})`
        : `linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 0%), url(${illustrationImage})`
      : undefined,
  };

  const doneDeckInlineStyle = {
    backgroundImage: illustrationImage
      ? `linear-gradient(rgba(176, 242, 182, 0.58), rgba(176, 242, 182, 0.58)),  url(${illustrationImage})`
      : `linear-gradient(rgba(176, 242, 182, 0.58), rgba(176, 242, 182, 0.58))`,
  };

  return (
    <Card className={classes.cardRoot} elevation={0}>
      <CardActionArea onClick={onCardClick} disableRipple disableTouchRipple>
        <CardContent className={classes.cardContent}>
          <Box className={classes.progressContainer}>
            <QuadraticProgress
              className={classes.progress}
              value={deck.percent}
              textValue={progressValue}
              isLock={isLock}
              colorText
              showCompletionBadge={false}
              style={isCompleted ? doneDeckInlineStyle : cardInlineStyle}
            />
            {isCompleted && <LessonCompletedIcon />}
          </Box>
          <Box className={classes.deckName}>
            <Typography>{deck.name}</Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default DeckCard;
